<template>
	<div class="container-fluid">
		<template
			v-for="(menu, index) in filteredMenus">
			<h3 :key="`title-${index}`">{{ menu.label }}</h3>
			<div class="row" :key="`container-${index}`">
				<div
					v-for="(childMenu, indexChild) in filteredChildren(menu.children)"
					class="col-sm-6 col-md-3"
					:key="indexChild">
					<router-link
						class="box text-center d-block text-decoration-none"
						:to="childMenu.link">
						<i class="material-icons md-36 mt-2">{{ childMenu.icon }}</i>
						<h2 class="overview__number">{{ childMenu.label }}</h2>
					</router-link>
				</div>
			</div>
			<hr class="mb-4" :key="`hr-${index}`">
		</template>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
	name: 'AdminHome',
	data() {
		return {
			menus: [
				// General
				{
					label: 'General',
					is_title: true,
					capabilities: ['admin_statistic_view', 'admin_users_view', 'admin_supplier_view', 'admin_monitoring_orders_view', 'admin_setting_view', 'admin_activity_log_view', 'admin_export_page_view'],
					children: [
						{
							label: 'Statistic',
							icon: 'insert_chart_outlined',
							link: '/admin/stats',
							slug: 'statistics',
							capabilities: 'admin_statistic_view',
						},
						{
							label: 'Staff',
							icon: 'people',
							link: '/admin/user/staff',
							slug: 'user',
							capabilities: 'admin_users_staff_view',
						},
						{
							label: 'Seller',
							icon: 'people',
							link: '/admin/user/seller',
							slug: 'user',
							capabilities: 'admin_users_view',
						},
						{
							label: 'Suppliers',
							icon: 'account_box',
							link: '/admin/supplier',
							slug: 'supplier',
							capabilities: 'admin_supplier_view',
						},
						{
							label: 'Orders Monitoring',
							icon: 'search',
							link: '/admin/orders',
							slug: 'orders',
							capabilities: 'admin_monitoring_orders_view',
						},
						{
							label: 'Wholesale Orders',
							icon: 'saved_search',
							link: '/admin/wholesale-order',
							slug: 'private-order',
							capabilities: 'admin_private_order_view',
						},
						{
							label: 'Monitoring Fraud',
							icon: 'person_off',
							link: '/admin/fraud-monitoring',
							slug: 'fraud-monitoring',
							capabilities: 'admin_fraud_monitoring_view',
						},
						{
							label: 'Leads Orders',
							icon: 'shopping_cart',
							link: '/admin/leads-order',
							slug: 'leads-order',
							capabilities: 'admin_leads_order_view',
						},
						{
							label: 'Warehouses',
							icon: 'warehouse',
							link: '/admin/warehouse',
							slug: 'admin_warehouse',
							capabilities: 'admin_homepage_view',
						},
						{
							label: 'Announcements',
							icon: 'campaign',
							link: '/admin/announcements',
							slug: 'admin_announcements',
							capabilities: 'admin_homepage_view',
						},
						{
							label: 'Popup Information',
							icon: 'open_in_new',
							link: '/admin/popup-information',
							slug: 'homepage',
							capabilities: 'admin_popup_information_view',
						},
						{
							label: 'Settings',
							icon: 'settings',
							link: '/admin/settings',
							slug: 'settings',
							capabilities: 'admin_setting_view',
						},
						{
							label: 'Log Activities',
							icon: 'history',
							link: '/admin/activity-log',
							slug: 'activity-log',
							capabilities: 'admin_activity_log_view',
						},
						{
							label: 'Export Page',
							icon: 'ios_share',
							link: '/admin/export-page',
							slug: 'export-page',
							capabilities: 'admin_export_page_view',
						},
						{
							label: 'OTP Page',
							icon: 'key',
							link: '/admin/otp',
							slug: 'admin-otp',
							capabilities: 'admin_otp_page_view',
						},

					],
				},
				// Product
				{
					label: 'Product',
					is_title: true,
					capabilities: ['admin_product_view', 'admin_ticket_view', 'admin_ask_stock_view'],
					children: [
						{
							label: 'Product List',
							icon: 'shopping_bag',
							link: '/admin/products',
							slug: 'products',
							capabilities: 'admin_product_view',
						},
						{
							label: 'Tanyakan Stock',
							icon: 'sms',
							link: '/admin/ask-stocks',
							slug: 'ask-stocks',
							capabilities: 'admin_ask_stock_view',
						},
						{
							label: 'Marketing Kit',
							icon: 'image',
							link: '/admin/marketing-kit',
							slug: 'marketing-kit',
							capabilities: 'admin_product_view',
						},
						{
							label: 'Monitoring Ticket',
							icon: 'confirmation_number',
							link: '/admin/ticket',
							slug: 'ticket',
							capabilities: 'admin_ticket_view',
						},
						{
							label: 'Monitoring Stock',
							icon: 'all_inbox',
							link: '/admin/monitoring-stock',
							slug: 'monitoring-stock',
							capabilities: 'admin_monitoring_stock_view',
						},
						{
							label: 'Change Source',
							icon: 'sync_alt',
							link: '/admin/change-source',
							slug: 'change-source',
							capabilities: 'admin_change_source_view',
						},
					],
				},
				// Commercial
				{
					label: 'Commercial',
					is_title: true,
					capabilities: ['admin_sales_view', 'admin_monitoring_sales_view'],
					children: [
						{
							label: 'Sales',
							icon: 'person',
							link: '/admin/sales',
							slug: 'sales',
							capabilities: 'admin_sales_view',
						},
						{
							label: 'Monitoring Sales',
							icon: 'pie_chart',
							link: '/admin/monitoring-sales',
							slug: 'sales',
							capabilities: 'admin_monitoring_sales_view',
						},
					],
				},
				// Finance
				{
					label: 'Finance',
					is_title: true,
					capabilities: ['admin_withdrawal_view', 'admin_billing_view', 'admin_finance_view'],
					children: [
						{
							label: 'Withdrawals',
							icon: 'credit_card',
							link: '/admin/withdrawals',
							slug: 'withdrawals',
							capabilities: 'admin_withdrawal_view',
						},
						{
							label: 'Billings',
							icon: 'business_center',
							link: '/admin/billings',
							slug: 'billings',
							capabilities: 'admin_billing_view',
						},
						{
							label: 'Finance',
							icon: 'credit_card',
							link: '/admin/finance',
							slug: 'finance',
							capabilities: 'admin_finance_view',
						},
						{
							label: 'Supplier Wallet',
							icon: 'wallet',
							link: '/admin/supplier-wallet',
							slug: 'supplier-wallet',
							capabilities: 'admin_finance_view',
						},
						{
							label: 'Seller Wallet',
							icon: 'wallet',
							link: '/admin/dropshipper-wallet',
							slug: 'dropshipper-wallet',
							capabilities: 'admin_finance_view',
						},
						{
							label: 'Wallet Draft',
							icon: 'wallet',
							link: '/admin/wallet-draft',
							slug: 'wallet-draft',
							capabilities: 'admin_finance_view',
						},
						{
							label: 'Revenue Stream',
							icon: 'payments',
							link: '/admin/revenue-stream',
							slug: 'revenue-stream',
							capabilities: 'admin_finance_view',
						},
						{
							label: 'Handling Fee',
							icon: 'account_balance_wallet',
							link: '/admin/handling-fee',
							slug: 'handling-fee',
							capabilities: 'admin_finance_view',
						},
						{
							label: 'Credit Cancel',
							icon: 'credit_card_off',
							link: '/admin/credit-cancel',
							slug: 'credit-cancel',
							capabilities: 'admin_credit_cancel',
						},
					],
				},
				// Request
				{
					label: 'Request',
					is_title: true,
					capabilities: ['admin_homepage_view'],
					children: [
						{
							label: 'Brand',
							icon: 'sell',
							link: '/admin/brand',
							slug: 'admin_brand',
							capabilities: 'admin_homepage_view',
						},
						{
							label: 'Direct',
							icon: 'drive_file_move',
							link: '/admin/direct',
							slug: 'admin_direct',
							capabilities: 'admin_homepage_view',
						},
						{
							label: 'Request Product',
							icon: 'inventory_2',
							link: '/admin/request-product',
							slug: 'admin_product_request',
							capabilities: 'admin_homepage_view',
						},
					],
				},
				// Site
				{
					label: 'Site',
					is_title: true,
					capabilities: ['admin_slide_banner_view', 'admin_homepage_view'],
					children: [
						{
							label: 'Slider Banner',
							icon: 'photo_library',
							link: '/admin/slider',
							slug: 'slider',
							capabilities: 'admin_slide_banner_view',
						},
						{
							label: 'Slider Banner Supplier',
							icon: 'photo_library',
							link: '/admin/supplier-slider',
							slug: 'supplier-slider',
							capabilities: 'admin_slide_banner_view',
						},
						{
							label: 'Slider Banner Wholesale',
							icon: 'photo_library',
							link: '/admin/wholesale-slider',
							slug: 'wholesale-slider',
							capabilities: 'admin_slide_banner_view',
						},
						{
							label: 'Homepage',
							icon: 'display_settings',
							link: '/admin/homepage',
							slug: 'homepage',
							capabilities: 'admin_homepage_view',
						},
					],
				},
			],
		};
	},
	computed: {
		...mapGetters({
			user: 'user',
			isAdmin: 'isAdmin',
			isSupport: 'isSupport',
			isHasFeature: 'isHasFeature',
			isUserCan: 'isUserCan',
		}),
		isTabSelected() {
			return this.tab === '';
		},
		filteredMenus() {
			return this.menus.filter(curr => this.isHasMenuAccess(curr));
		},
	},
	methods: {
		isHasMenuAccess(menu) {
			let hasAccess = false;
			menu.capabilities.forEach((capability) => {
				if (this.isUserCan(capability)) {
					hasAccess = true;
				}
			});
			return hasAccess;
		},
		filteredChildren(children) {
			return children.filter(curr => this.isUserCan(curr.capabilities));
		},
	},
};
</script>
